import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress,
    Typography,
    TableCell,
    
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { getAlllearnerAttendance } from "../../services/AttendanceServices";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
    },
    "&.MuiTableCell-body": {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const AttendanceHistory = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const user = JSON.parse(localStorage.getItem("user"));

    const fetchLabDetails = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await getAlllearnerAttendance(user?.learner?.learner_id);
            setRows(response?.data?.data || []);
        } catch (error) {
            setError("Failed to fetch attendance data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLabDetails();
    }, []);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (datetime) => {
        if (!datetime) return "-";
        return new Date(datetime).toLocaleDateString();
    };

    const formatTime = (datetime) => {
        if (!datetime) return "-";
        return new Date(datetime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };

    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <Typography pt={2} pb={4} width="100%" 
            sx={{
                fontSize: "20px !important",
                fontWeight: "600 !important",
                color: "rgb(189, 189, 189)",
            }}>
                Welcome {JSON.parse(localStorage.getItem("user"))?.learner.name || "User"}! to the Attendance History.
            </Typography>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Typography color="error" align="center">
                    {error}
                </Typography>
            ) : rows.length === 0 ? (
                <Typography align="center" color="textSecondary">
                    No attendance records available.
                </Typography>
            ) : (
                <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
                    <Table sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Date</StyledTableCell>
                                <StyledTableCell>Check-In Time</StyledTableCell>
                                <StyledTableCell>Check-Out Time</StyledTableCell>
                                <StyledTableCell>Duration</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>{formatDate(row.create_date)}</StyledTableCell>
                                    <StyledTableCell>{formatTime(row.inDateTime)}</StyledTableCell>
                                    <StyledTableCell>{formatTime(row.outDateTime)}</StyledTableCell>
                                    {/* <StyledTableCell>
                      {row.inDateTime && row.outDateTime
                        ? `${((new Date(row.outDateTime) - new Date(row.inDateTime)) / 1000 / 60).toFixed(2)} mins`
                        : "-"}
                    </StyledTableCell> */}
                                    <StyledTableCell>
                                        {row.inDateTime && row.outDateTime ? (
                                            (() => {
                                                const inTime = new Date(row.inDateTime);
                                                const outTime = new Date(row.outDateTime);

                                                if (isNaN(inTime) || isNaN(outTime)) {
                                                    return "-";
                                                }

                                                const diffInMinutes = (outTime - inTime) / (1000 * 60);
                                                return `${diffInMinutes.toFixed(2)} mins`;
                                            })()
                                        ) : (
                                            "-"
                                        )}
                                    </StyledTableCell>

                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            )}
        </Box>
    );
};

export default AttendanceHistory;
